export const formFields = [
  {
    section: "Table",
    name: "ps4PtPaySchTableName",
    label: "Table",
    fieldLabel: "PS4 Pt Pay Sch Table Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 13, message: "MAXLENGTH_13" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [5, 10],
  },
  {
    section: "Table",
    name: "ps4PatPayDescription",
    label: "Description",
    fieldLabel: "PS4 Pat Pay Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 10],
  },
  {
    section: "Table",
    name: "p4xDisplayRecord",
    label: "Display",
    fieldLabel: "ADX Display Record",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 10],
  },

  {
    section: "Table",
    name: "ps4CopayComparisonCode",
    label: "Patient Pay Comparison Code",
    fieldLabel: "PS4 Copay Comparison Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 10],
  },

  {
    section: "Table",
    name: "ps4BalanceOverride",
    label: "Balance Override",
    fieldLabel: "PS4 Balance Override",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 10],
  },

  {
    section: "Table",
    name: "ps4MinimumCopay",
    label: "Minimum Patient Pay $",
    fieldLabel: "PS4 Minimum Copay",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 10],
  },

  {
    section: "Use Generic Section for PSC:",
    name: "",
    label: "Use Generic Section for PSC:",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [16, 10],
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc0",
    label: "0",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 10],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc1",
    label: "1",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 12],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc2",
    label: "2",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 14],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc3",
    label: "3",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 16],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc4",
    label: "4",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 18],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc5",
    label: "5",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 20],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc6",
    label: "6",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 22],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc7",
    label: "7",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 24],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc8",
    label: "8",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 26],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Use Generic Section for PSC",
    name: "ps4GenericPatPayPsc9",
    label: "9",
    fieldLabel: "PS4 Generic Pat Pay-PSC 0",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 28],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },

  {
    section: "Negative Due",
    name: "ps4NegativeAmtDueYN",
    label: "Negative Due",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 10],
  },
  {
    section: "Negative Due",
    name: "ps4NegdueSubmissionFee",
    label: "Negative Due Submission Fee",
    fieldLabel: "PS4 NegDue Submission Fee",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 10],
  },
  {
    section: "Negative Due",
    name: "ps4MaxNegDueIndicator",
    label: "Max Negative Due Indicator",
    fieldLabel: "PS4 Max Neg Due Indicator",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 10],
  },

  {
    section: "Negative Due",
    name: "ps4MaxNegativeAmtDue",
    label: "Max Neg Due",
    fieldLabel: "PS4 Max Negative Amt Due",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 10],
  },
  {
    section: "Negative Due",
    name: "ps4MaxNegDuePercent",
    label: "Max Negative Due Percent",
    fieldLabel: "PS4 Max Neg Due Percent",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 10],
  },

  {
    section: "Negative Due",
    name: "ps4MaxNegDueQualifier",
    label: "Max Negative Due Percent Qualifier",
    fieldLabel: "PS4 Max Neg Due Qualifier",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [27, 10],
  },
  {
    section: "Table",
    name: "ps4MinMaxType",
    label: "Min/Max Type",
    fieldLabel: "PS4 Min/Max Type",
    type: "dropdown",
    dropdownCondition: "Valid values for Min/Max",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 10],
  },

  {
    section: "Brand(Header)",
    name: "ps4BrandCopayAmt",
    label: "Amount",
    fieldLabel: "PS4 Brand: Copay Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandCopayPct",
    label: "Percent",
    fieldLabel: "PS4 Brand: Copay Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandSplitTabPct",
    label: "Split Tab Percent",
    fieldLabel: "PS4 Brand: Split Tab Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandSplTabPctQu",
    label: "",
    fieldLabel: "PS4 Brand: Spl Tab Pct Qu",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 12],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandCopaycalcbasis",
    label: "Calc Basis",
    fieldLabel: "PS4 Brand: CopayCalcBasis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 10],
  },

  {
    section: "Brand(Header)",
    name: "ps4BrandCostSource",
    label: "Cost Source",
    fieldLabel: "PS4 Brand: Cost Source",
    type: "lookup",
    externalProgram: { default: "RCCSS001" },
    viewType: "legacy",
    params: {
      lookupType: "local",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ps4BrandCostSource",
            target: "source",
            paramDataKey: "source",
            legacy: "cssCostSource",
          },
          {
            source: "ps4BrandCostCode",
            target: "type",
            legacy: "cssCostType",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [31, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandCostCode",
    label: "Cost Code",
    fieldLabel: "PS4 Brand: Cost Code",
    type: "lookup",
    externalProgram: { default: "RCCSS001" },
    viewType: "legacy",
    params: {
      lookupType: "local",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ps4BrandCostSource",
            target: "source",
            legacy: "cssCostSource",
          },
          {
            source: "ps4BrandCostCode",
            target: "type",
            legacy: "cssCostType",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [31, 12],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandDifferentialcd",
    label: "Differential Code",
    fieldLabel: "PS4 Brand: DifferentialCd",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandDifferentlPct",
    label: "Differential Percent",
    fieldLabel: "PS4 Brand: Differentl Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 12],
  },

  {
    section: "Brand(Header)",
    name: "",
    label: "Use Differential Section for PSC:",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [33, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPscA",
    label: "A",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 11],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc0",
    label: "0",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 12],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc1",
    label: "1",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 13],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc2",
    label: "2",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 14],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc3",
    label: "3",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 15],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc4",
    label: "4",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 16],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc5",
    label: "5",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 17],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc6",
    label: "6",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 18],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc7",
    label: "7",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 19],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc8",
    label: "8",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 20],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandUseDiffPsc9",
    label: "9",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [34, 21],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },

  {
    section: "Brand(Header)",
    name: "ps4BrandCopaySchedule",
    label: "Copay Sched & Step",
    fieldLabel: "PS4 Brand: Copay Schedule",
    type: "lookup",
    externalProgram: { default: "RCCSH004" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "ps4BrandCopaySchedule",
            target: "cscCopayScheduleName",
            paramDataKey: "cscCopayScheduleName",
            navigateDataKey: "cshCopayScheduleId",
          },
          { source: "brandCopayScheduleDesc", target: "cshCopayScheduleDesc" },
          { source: "ps4BrandCopayschedstep", target: "cscStepNbr" },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [40, 10],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandCopayschedstep",
    label: "",
    fieldLabel: "PS4 Brand: CopaySchedStep",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [40, 12],
  },
  {
    section: "Brand(Header)",
    name: "ps4BrandCopayCalccode",
    label: "Calc Code",
    fieldLabel: "PS4 Brand: Copay CalcCode",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [41, 10],
  },

  {
    section: "Generic(Header)",
    name: "ps4GenrcCopayAmt",
    label: "Amount",
    fieldLabel: "PS4 Genrc: Copay Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [43, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCopayPct",
    label: "Percent",
    fieldLabel: "PS4 Genrc: Copay Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [44, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcSplitTabPct",
    label: "Split Tab Percent",
    fieldLabel: "PS4 Genrc: Split Tab Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [45, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcSplTabPctQu",
    label: "",
    fieldLabel: "PS4 Brand: Spl Tab Pct Qu",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [45, 12],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCopaycalcbasis",
    label: "Calc Basis",
    fieldLabel: "PS4 Genrc: CopayCalcBasis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [46, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCostSource",
    label: "Cost Source",
    fieldLabel: "PS4 Genrc: Cost Source",
    type: "lookup",
    externalProgram: { default: "RCCSS001" },
    viewType: "legacy",
    params: {
      lookupType: "local",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ps4GenrcCostSource",
            target: "source",
            legacy: "cssCostSource",
          },
          {
            source: "ps4GenrcCostCode",
            target: "type",
            legacy: "cssCostType",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [48, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCostCode",
    label: "Cost Code",
    fieldLabel: "PS4 Genrc: Cost Code",
    type: "lookup",
    externalProgram: { default: "RCCSS001" },
    viewType: "legacy",
    params: {
      lookupType: "local",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ps4GenrcCostSource",
            target: "source",
            legacy: "cssCostSource",
          },
          {
            source: "ps4GenrcCostCode",
            target: "type",
            legacy: "cssCostType",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [48, 12],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcDifferentialcd",
    label: "Differential Code",
    fieldLabel: "PS4 Brand: DifferentialCd",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [49, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcDifferentlPct",
    label: "Differential Percent",
    fieldLabel: "PS4 Genrc: Differentl Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [49, 12],
  },
  {
    section: "Generic(Header)",
    name: "",
    label: "Use Differential Section for PSC:",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [50, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPscA",
    label: "A",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 11],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc0",
    label: "0",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 12],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc1",
    label: "1",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 13],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc2",
    label: "2",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 14],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc3",
    label: "3",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 15],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc4",
    label: "4",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 16],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc5",
    label: "5",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 17],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc6",
    label: "6",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 18],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc7",
    label: "7",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 19],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc8",
    label: "8",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 20],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcUseDiffPsc9",
    label: "9",
    fieldLabel: "PS4 Brand: Use Diff-PSC A",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [51, 21],
    autoItemWidth: true,
    showDropdownOriginalValue: true,
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCopaySchedule",
    label: "Copay Sched & Step",
    fieldLabel: "PS4 Genrc: Copay Schedule",
    type: "lookup",
    externalProgram: { default: "RCCSH004" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "ps4GenrcCopaySchedule",
            target: "cshCopayScheduleId",
            lookupDataKey: "cscCopayScheduleName",
          },
          {
            source: "genericCopayScheduleDesc",
            target: "cshCopayScheduleDesc",
          },
          { source: "ps4GenrcCopayschedstep", target: "cscStepNbr" },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [57, 10],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCopayschedstep",
    label: "",
    fieldLabel: "PS4 Genrc: CopaySchedStep",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [57, 12],
  },
  {
    section: "Generic(Header)",
    name: "ps4GenrcCopayCalccode",
    label: "Calc Code",
    fieldLabel: "PS4 Genrc: Copay CalcCode",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [58, 10],
  },

  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 10],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 12],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 14],
  },
  {
    section: "New Audit Fields",
    name: "additionalPPExists",
    label: "Additional Patient Pay Exist",
    fieldLabel: "AdditionalPatientPayExist",
    type: "dropdown",
    dropdownCondition: "Yes or No",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 16],
  },
  {
    section: "New Audit Fields",
    name: "minmaxExists",
    label: "Min/Max Exist",
    fieldLabel: "Min/MaxExist",
    type: "dropdown",
    dropdownCondition: "Yes or No",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 18],
  },
  {
    section: "New Audit Fields",
    name: "noteExistenceStatus",
    label: "Notes Exist",
    fieldLabel: "Note Values",
    type: "dropdown",
    dropdownCondition: "Yes or No",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [59, 20],
  },
];